'use client';

import { type ReactNode, useCallback, useState } from 'react';
import { createSafeContext } from '@/utils/react';

interface CartDrawerContextValue {
  isOpen: boolean;
  onSetCartState: (state: boolean) => void;
  onCartOpen: () => void;
  onCartClose: () => void;
  onCartToggle: () => void;
}

const [CartDrawerProvider, useCartDrawerContext] = createSafeContext<CartDrawerContextValue>('CartDrawerContext');

interface CartDrawerProviderProps {
  children: ReactNode;
}

export function CartDrawerContextProvider({ children }: CartDrawerProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onSetCartState = (state: boolean) => {
    setIsOpen(state);
  };

  const onCartOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onCartClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onCartToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <CartDrawerProvider
      value={{
        isOpen,
        onSetCartState,
        onCartOpen,
        onCartClose,
        onCartToggle,
      }}
    >
      {children}
    </CartDrawerProvider>
  );
}

export const useCartDrawer = useCartDrawerContext;
